<template>
	<div>
		<footer class="section bg-black">
		    <div class="footer-top section-padding">
		        <div class="container">
		            <div class="row row-cols-lg-5 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n8">
		                <div class="col mb-8">
		                    <div class="footer-widget footer-about">
		                        <div class="footer-logo" style="display: flex;align-items: center;">
		                            <router-link :to="{ path: '/index'}"><img src="@/assets/images/logo/logo.png" alt="logo"></router-link>
									<div>
										<p>筑壳</p>
										<p>建筑场景化装饰平台</p>
									</div>
		                        </div>
		                    </div>
		                </div>
		                <div class="col mb-8">
		                    <div class="footer-widget footer-list">
		                        <h3 class="footer-title">分类</h3>
		                        <ul>
									<li><router-link :to="{ path: '/project'}" tag="a" target="_blank">案例</router-link></li>
									<li><router-link :to="{ path: '/specialColumn' }" tag="a" target="_blank">专栏</router-link></li>
									<li><router-link :to="{ path: '/product' }" tag="a" target="_blank">产品</router-link></li>
									<li><router-link :to="{ path: '/show' }" tag="a" target="_blank">展厅</router-link></li>
									<li><router-link :to="{ path: '/exhibition' }" tag="a" target="_blank">展会</router-link></li>
									<li><router-link :to="{ path: '/appDownload' }" tag="a" target="_blank">筑壳客户端</router-link></li>
		                        </ul>
		                    </div>
		                </div>
		                <div class="col mb-8">
		                    <div class="footer-widget footer-list">
		                        <h3 class="footer-title">关于我们</h3>
		                        <ul>
		                            <li>
		                                <span class="title"><i class="dlicon ui-2_phone"></i></span>
										<span class="desc">
											<router-link tag="a" target="_blank" :to="{ path: '/aboutUs'}">关于我们</router-link>
										</span>
		                            </li>
		                            <li>
		                                <span class="title"><i class="dlicon ui-1_email-85"></i></span>
		                                <span class="desc"><router-link tag="a" target="_blank" :to="{ path: '/contant'}">加入我们</router-link></span>
		                            </li>
		                            <li>
		                                <span class="title"><i class="dlicon ui-1_home-51"></i></span>
		                                <span class="desc">
											<router-link tag="a" target="_blank" :to="{ path: '/copyrightNotice'}">版权声明</router-link>
										</span>
		                            </li>
		                        </ul>
		                    </div>
		                </div>
		                <div class="col mb-8">
		                    <div class="footer-widget footer-newsletter">
		                        <h3 class="footer-title">申请入驻</h3>
		                        <div id="mc_embed_signup" class="subscribe-form">
		                            <form id="mc-embedded-subscribe-form" class="validate" novalidate="" target="_blank" name="mc-embedded-subscribe-form" method="post" action=" ">
		                                <div id="mc_embed_signup_scroll" class="mc-form">
		                                    <Input v-model="phone" style="margin-bottom: 10px;" size="large" placeholder="请输入认证手机号"  />
		                                    <Select v-model="cate_id" size="large" style="height:50px;margin-bottom: 20px;">
		                                    	<Option v-for="item in cateList" :value="item.id" :key="item.id">{{ item.cate_name }}</Option>
		                                    </Select>
		                                    <Button type="success"   size="large" @click="userApply">提交申请</Button>
		                                </div>
		                            </form>
		                        </div>
		                    </div>
		                </div>
						<div class="col mb-8">
		                    <div class="footer-widget footer-list">
		                        <h3 class="footer-title">关注我们</h3>
		                       <div class="social-icon-style mb-5">
		                           <a class="facebook" href="#"><i class="fa fa-facebook"></i></a>
		                           <a class="twitter" href="#"><i class="fa fa-twitter"></i></a>
		                           <a class="google-plus" href="#"><i class="fa fa-google-plus"></i></a>
		                           <a class="behance" href="#"><i class="fa fa-behance"></i></a>
		                       </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		    <div class="footer-bottom">
		        <div class="container">
		            <div class="copyright text-center">
		                <p>
		                    筑壳(深圳)科技有限公司 | 备案号：粤ICP备2022044914号-1
		                </p>
		            </div>
		        </div>
		    </div>
		</footer>
	</div>
</template>

<script>
	import { getCookies, removeCookies } from '@/libs/util'
	import {
		userApply
	 } from '@/api'
	 export default {
	   data() {
			return {
				cateList: [
					{id: 1,  cate_name: "设计公司"},
					{id: 2,  cate_name: "装修公司"},
					{id: 3,  cate_name: "材料供应商"},
					{id: 4,  cate_name: "咨询/顾问公司"}
				],
				
				phone: '',
				cate_id: ''
			}
		},
		computed: {
			isLogin() {
			  return getCookies("webtoken");
			},
		},
		methods:{
			// 提交认证
			async userApply() {
			if (!this.phone) {
				this.$Message.warning('请填写手机号码');
				return 
			}
			if (!/^1(3|4|5|7|8|9|6)\d{9}$/i.test(this.phone)) {
				this.$Message.warning('请输入正确的手机号码');
				return 
			}
			if(!this.cate_id) {
				this.$Message.warning('请选择入驻类型');
				return 
			}
				await userApply({
					phone: this.phone,
					cate_id: this.cate_id
				}).then(res => {
					this.$Message.success('提交成功');
					this.phone = ''
					this.cate_id = ''
				}).catch(err => {
					this.$Message.success('提交成功');
					this.phone = ''
					this.cate_id = ''
				})
			},
			
		}
	}
</script>

<style>
</style>
